import React, {Component} from 'react';
import {Header} from '../Header';
import {Footer} from '../Footer';
import {Helmet} from "react-helmet";

export class AccessibilitySE extends Component {
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>Tillgänglighetsredogörelse - CamAPS FX</title>
                    <meta name="title" content="Tillgänglighetsredogörelse"/>
                    <meta name="description"
                          content="CamDiab arbetar för att underlätta och förbättra tillgängligheten och användbarheten hos sina digitala produkter för alla människor, inklusive personer med funk"/>
                    <meta property="og:locale" content="sv"/>
                    <meta name="keywords" content="tillgänglighetsredogörelse"/>
                </Helmet>
                <Header props={this.props}/>
                <section className="inner-banner">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 col-sm-10">
                                <h1>Tillgänglighetsredogörelse</h1>
                                <h3>Version daterad den 11 september 2026</h3>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="inner-page-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-sm-12">
                                <p>
                                    CamDiab arbetar för att underlätta och förbättra tillgängligheten och användbarheten hos sina digitala produkter för alla människor, inklusive personer med funktionsnedsättning.
                                </p>
                                <h2>
                                    Status för överensstämmelse
                                </h2>
                                <p>
                                    CamDiab strävar efter att uppfylla Riktlinjer för tillgängligt webbinnehåll (WCAG) version 2.2, nivå AA (WCAG 2.2 AA). Dessa globalt erkända riktlinjer bidrar till att göra webbinnehåll mer tillgängligt för alla.
                                </p>
                                <h2>
                                    Ytterligare åtgärder för att stödja tillgänglighet
                                </h2>
                                <p>
                                    CamDiab vidtar bland annat följande ytterligare åtgärder för att göra vårt digitala innehåll enklare att använda:
                                </p>
                                <ul>
                                    <li>Erbjuda kontinuerlig utbildning om tillgänglighet för vår personal</li>
                                    <li>Använda formella metoder för kvalitetssäkring av tillgänglighet genom bedömningar av tredje part</li>
                                    <li>Fastställa tydliga mål och ansvarsområden för tillgänglighet</li>
                                </ul>
                                <h2>
                                    Feedback
                                </h2>
                                <p>
                                    Vi välkomnar synpunkter på hur vi kan förbättra våra digitala produkter för användare med funktionsnedsättning. Om du har svårt att visa eller navigera i vårt innehåll, eller om du upptäcker innehåll, funktioner eller funktionalitet som du anser inte är fullt tillgängliga för personer med funktionsnedsättning, vänligen kontakta oss via vår supportadress: <a href="mailto:support@camdiab.com">support@camdiab.com</a>
                                </p>
                                <p>
                                    Vi tar din feedback på allvar och kommer att ta hänsyn till den när vi utvärderar hur vi kan tillgodose alla våra kunders behov och utveckla våra övergripande tillgänglighetspolicyer. Även om vi inte har kontroll över innehåll som tillhandahålls av tredjepartsleverantörer, uppmuntrar vi dem starkt att tillhandahålla innehåll som är tillgängligt och användarvänligt.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer props={this.props}/>
            </div>
        );
    }
}
